import { render } from "./KontaktForm.vue?vue&type=template&id=6025a7f1&scoped=true"
import script from "./KontaktForm.vue?vue&type=script&lang=js"
export * from "./KontaktForm.vue?vue&type=script&lang=js"

import "./KontaktForm.vue?vue&type=style&index=0&id=6025a7f1&scoped=true&lang=css"

import exportComponent from "/Users/gabrielvoirol/git_projects/df_wpheadless/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6025a7f1"]])

export default __exports__